import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const adminRoutes: RouteConfig = {
  path: '/admin',
  component: Layout,
  redirect: 'noRedirect',
  name: 'Administration',
  meta: {
    title: 'adminMenu',
    icon: 'tree-table',
    roles: ['Admin']
  },

  children: [
    {
      path: 'https://xd.adobe.com/view/e126b449-e9ad-4ab9-9830-5f2b7a2225ce-b475/screen/f10bfd6b-f860-4c41-a98d-d0104a35f4dc/',
      meta: {
        title: 'styleGuideLink',
        icon: 'link'
      }
    },
    {
      path: 'https://www.cubi.casa/',
      meta: {
        title: 'cubiCasaLink',
        icon: 'link'
      }
    },
    {
      path: '*',
      redirect: '/404',
      meta: { hidden: true }
    },
    {
      path: '/icon',
      component: () => import(/* webpackChunkName: "icons" */ '@/views/icons/index.vue'),
      name: 'Icons',
      meta: {
        title: 'icons',
        icon: 'icon',
        noCache: true
      }
    }
  ]
}

export default adminRoutes
